import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, SimpleChange, OnChanges, SimpleChanges, AfterContentChecked, ChangeDetectorRef, Directive } from "@angular/core";
import { EnvironmentService } from "../../../services/environment.service";
import { HelperService } from "../../../services/helper/helper.service";
import { AuthenticationService } from "../../services/authentication.service";
import { Observable } from "rxjs";
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';


import * as AldModels from '../../../models/ald/ald';
import { AldState } from "../../../services/ald/ald.state";
import * as AldActions from "../../../services/ald/ald.action";
import * as Models from '../../../models/commonModels';

import * as RelocationOrderModels from '../../../models/relocation-order/relocation-order';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl,
  FormGroupName,
  ValidatorFn,
  AbstractControlOptions,
} from "@angular/forms";
import { FormBaseComponent } from "./form.component";

import { User } from '../../../models/user/user';

@Directive()
export abstract class AldFormBaseComponent extends FormBaseComponent implements OnInit {

  public version = 'develop';

  public currentUser: User;

  public summary: AldModels.AldSummaryModel;

  public requestGetSummary: Models.RequestModel = null;

  public requestGetDeposite: Models.RequestModel = null;

  public requestGetTyreOrder: Models.RequestModel = null;

  public requestGetCar: Models.RequestModel = null;

  public toolTipGarageVisit: string = " Umów wizytę.";

  public toolTipGarageVisitRequest: string = "Brak kompletu opon w serwisie. Poproś o umówienie wizyty.";

  public toolTipRelocation: string = "Relokuj depozyt.";

  public toolDepositeInOrder: string = "Depozyt jest powiązany z aktualnie realizowanym zleceniem.";


  @Select(AldState.Summary)
  Summary$: Observable<Models.Response<AldModels.AldSummaryModel>>;

  constructor(
    public helperService: HelperService,
    public environmentService: EnvironmentService,
    public changeDetectionRef: ChangeDetectorRef,
    public router: Router,
    public authenticationService: AuthenticationService,
    public store: Store,
  ) {
    super(helperService, environmentService, changeDetectionRef);
  }

  localizationCalendarConfig = {
    firstDayOfWeek: 0,
    dayNames: [
      'Niedziela',
      'Poniedziałek',
      'Wtorek',
      'Środa',
      'Czwartek',
      'Piątek',
      'Sobota',
    ],
    dayNamesShort: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
    dayNamesMin: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
    monthNames: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    monthNamesShort: [
      'Sty',
      'Lut',
      'Mar',
      'Kwi',
      'Maj',
      'Cze',
      'Lip',
      'Sie',
      'Wrz',
      'Paź',
      'Lis',
      'Gru',
    ],
    today: 'Dzisiaj',
    clear: 'Wyczyść',
    dateFormat: 'dd.mm.yy',
    weekHeader: 'Tyg',
  };

  onHomePage() {
    if (this.currentUser) {
      this.router.navigate(['/car']);
    }
  }

  ngOnInit() {

    this.subscription.add(this.authenticationService.currentUser.subscribe((user) => {

      this.currentUser = user;

      if (!this.currentUser) {
        this.router.navigate(['/login']);
      }
      else {

        if(this.currentUser.CarId) {

          this.requestGetSummary = new Models.RequestModel(this.currentUser.CarId);

          this.store.dispatch(new AldActions.SummaryGet(this.requestGetSummary));

          this.onUserAuthenitcate();
        }
        else {

          //this.authenticationService.logout();

          //this.router.navigate(['/login']);
        }
      }
    }));

    this.subscription.add(this.Summary$.subscribe((data) => {
      if (data && data.Success) {
        this.summary = data.Item;

        this.onSummary();
      }
    }));
}

  public abstract onUserAuthenitcate();

  public abstract onSummary();

  onCarDetails() {
    if (this.currentUser) {
      this.router.navigate(['/car']);
    }
  }

  onHome() {
    if (this.currentUser) {
      this.router.navigate(['/home']);
    }
  }

  onVisits() {
    if (this.currentUser) {
      this.router.navigate(['/visits']);
    }
  }

  onDeposites() {
    if (this.currentUser) {
      this.router.navigate(['/deposites']);
    }
  }

  onTyreOrders() {
    if (this.currentUser) {
      this.router.navigate(['/tyre-orders']);
    }
  }

  onRelocationOrders() {
    if (this.currentUser) {
      this.router.navigate(['/relocation-orders']);
    }
  }

  onSetDefaultGarage() {
    if (this.currentUser) {
      this.router.navigate(['/default-garage']);
    }
  }
}
